export default __webpack_public_path__ + "static/media/institute-15-min.29a5c811.webp";